import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import ConfirmationDialog from '../confirmation/ConfirmationDialog';

import { closeNetworkErrorModal } from '../../store/actions/networkErrorModalAction';

interface NetworkErrorModalContainerProps  {
  networkErrorModal: { opened: boolean };
  closeModal: () => void;
};

class NetworkErrorModalContainer extends Component <NetworkErrorModalContainerProps> {

  render() {
    
    return (
      <Fragment>
        <ConfirmationDialog 
          title='Network error'
          text='Cannot communicate to server. Please try again.'
          open={ this.props.networkErrorModal.opened }
          close={ () => this.props.closeModal() }
          confirm={ () => this.props.closeModal() }
          textConfirm='Close'
          showCloseIcon={ false }
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    networkErrorModal: state.networkErrorModal
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    closeModal: () => dispatch(closeNetworkErrorModal())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NetworkErrorModalContainer);